module.exports = __webpack_public_path__ + "img/P150T_weapon_158.d1191d61.png";